import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const Cashier = lazy(() => import('./pages/cashier'));

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback='loading...'>
        <Routes>
          <Route exact path='/' element={<App></App>} />
          <Route path='/cashier' element={<Cashier></Cashier>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
